"use strict"

class Footer {
    constructor() {
        this.isMobile = false;
        this.isDesktop = false;
        this.breakpoint = 790;
        this.noResize = true;
        this.actu = document.querySelector('.sl-Actu');
        this.footer = document.querySelector('.sl-Footer');
        this.fullpage = document.querySelector('#fullpage')
    }
    renderMethodOnLoad() {
        window.innerWidth < this.breakpoint ? this.mobileMethod() : this.desktopMethod()
        window.innerWidth < this.breakpoint ? this.isDesktop = true : this.isMobile = true;
    }
    renderMethodOnResize() {
        window.onresize = () => {
            if (window.innerWidth < this.breakpoint) {
                this.isDesktop = true;
                if (this.isMobile) this.mobileMethod()
                this.isMobile = false;
            } else {
                this.isMobile = true;
                if (this.isDesktop) this.desktopMethod()
                this.isDesktop = false;
            }
        };
    }
    mobileMethod() {
        // remove footer from actus
        this.actu.removeChild(this.footer)
        this.footer.classList.add('fullpage-section');
        // set to fullpage rendering
        this.fullpage.appendChild(this.footer)
    }
    desktopMethod() {

    }
    setFullPage() {
        if (this.actu && document.querySelector('#landing')) {
            this.renderMethodOnLoad()
            if (this.noResize) this.renderMethodOnResize()
        }
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/scripts/components/Footer.js